/**
 * Example auth api connector that lets your user log in using a defined payload
 * and returns a promise
 *
 */

import vuex from '@/store'
import catchErrors from './catchErrors'

export default {
  getRoles(stations) {
    let params = {}
    if (stations) {
      params.stations = stations
    }
    return catchErrors.get(`/v2/newsdesk/roles`, {
      params,
      cache: {
        maxAge: 1000
      }
    })
  }
}
